import CharCreate from "./charcreate";

export interface diff {
    v: string,
    c: string[]
}

export const attributeRaiseChanges = ((attribute, current, maximum) => {
    let toDiff = ['s'];
    if (attribute === "ges") toDiff = toDiff.concat(['v']);
    if (attribute === "zae") toDiff = toDiff.concat(['bs', 'ts', 'ws', 'ep']);
    if (attribute === "wil") toDiff = toDiff.concat(['mr']);
    if (attribute === "cha") toDiff = toDiff.concat(['v']);
    const currentAssign = CharCreate.assign[current];

    let diffs: diff[] = [];
    for (let i = (current + 1); i <= maximum; i++) {
        let diff: string[] = [];
        const raisedAssign = CharCreate.assign[i];

        diff = []
        toDiff.forEach(diffField => {
            if (currentAssign[diffField] !== raisedAssign[diffField]) {
                const change = '+' + (raisedAssign[diffField] - currentAssign[diffField]);
                diff.push(CharCreate.assignMap[diffField] + ' ' + change);
            }
        });

        diffs.push({v: i, c: diff.length > 0 ? diff : []});
    }
    return diffs;
});